var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"categories"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"categories__wrapper"},_vm._l((_vm.categories),function(category,index){return _c('Card',{key:'dsk-' + index + category.url,staticClass:"categories__wrapper__list",class:_vm.getClass(index),attrs:{"category":category}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }